import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-06b43051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "page-full" }
const _hoisted_3 = { class: "py-8 flex flex-col items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  style: { height: '120px' },
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold mt-4 text-4xl text-gray-800" }, "Vue3-Charts", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "my-0 text-xl" }, "Data visualization in Vue3 made easy", -1))
const _hoisted_7 = { class: "my-6" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Get Started")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/ghalex/vue3-charts",
  class: "btn"
}, "GitHub", -1))
const _hoisted_10 = { class: "main-chart" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 p-8 rounded-lg mt-4 border border-gray-300" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold mb-4" }, "Gold Sponsors"),
  /*#__PURE__*/_createElementVNode("div", { class: "grid sm:grid-cols-2 gap-8" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://zapant.com",
      class: "sponsor"
    }, [
      /*#__PURE__*/_createElementVNode("img", { src: "/img/logozapant.png" })
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "sponsor"
    }, [
      /*#__PURE__*/_createElementVNode("img", { src: "/img/coderbox.png" })
    ])
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col mt-4 items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, "© 2021 ghalex. All Rights Reserved"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("Build with ❤️ by "),
    /*#__PURE__*/_createElementVNode("a", { href: "https://ghalex.com" }, "ghalex")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AreaChart = _resolveComponent("AreaChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navbar),
    _createVNode(_component_Sidebar, { class: "home-sidebar" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/docs/getting-started",
            class: "btn primary mr-4"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ChartBlock, {
            chartCode: _ctx.code.chartCode,
            dataCode: _ctx.code.dataCode
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AreaChart)
            ]),
            _: 1
          }, 8, ["chartCode", "dataCode"])
        ]),
        _hoisted_11,
        _hoisted_12
      ])
    ])
  ]))
}